import React, { useState } from 'react'
import Image from 'next/image'

import { Section } from '@/components/layout'
import { Tabs, Tab } from '@/components/common'
import useBreakpoint from '@/hooks/useBreakpoint'
import { MOBILE_BREAKPOINT } from '@/constants'
import quickbooksImg from '@/assets/integrations/logos/quickbooks.png'
import hrblockImg from '@/assets/integrations/logos/hrblock.png'
import quickenImg from '@/assets/integrations/logos/quicken.png'
import turbotaxImg from '@/assets/integrations/logos/turbotax.png'
import outlookImg from '@/assets/integrations/logos/outlook.png'
import campaignMonitorImg from '@/assets/integrations/logos/campaignMonitor.png'
import mailchimpImg from '@/assets/integrations/logos/mailchimp.png'
import googleContactsImg from '@/assets/integrations/logos/googleContacts.png'
import constantContactImg from '@/assets/integrations/logos/constantContact.png'

import IntegrationTabPanel from './IntegrationsTabsPanel'
import styles from './IntegrationsTabs.module.scss'

const integrationsList = [
  { name: 'quickbooks', hasDescription: true, width: 150, height: 31, img: quickbooksImg },
  { name: 'hrblock', numListItems: 4, width: 150, height: 26, img: hrblockImg },
  { name: 'quicken', width: 150, height: 36, img: quickenImg },
  { name: 'turbotax', numListItems: 4, width: 150, height: 34, img: turbotaxImg },
  { name: 'outlook', numListItems: 4, width: 150, height: 30, img: outlookImg },
  { name: 'campaignMonitor', width: 150, height: 16, img: campaignMonitorImg },
  { name: 'mailchimp', width: 150, height: 41, img: mailchimpImg },
  { name: 'googleContacts', width: 150, height: 36, img: googleContactsImg },
  { name: 'constantContact', width: 150, height: 23, img: constantContactImg },
]

export default function IntegrationsTabs() {
  const [selectedTabId, setSelectedTabId] = useState(integrationsList[0].name)
  const isDesktopWidth = useBreakpoint(MOBILE_BREAKPOINT)

  const renderTabs = () => integrationsList.reduce((acc, { name, width, height, img, ...rest }) => {
    const tabPanel = (
      <IntegrationTabPanel
        key={isDesktopWidth ? undefined : `${name}-panel`}
        className={isDesktopWidth ? undefined : styles.tabPanel}
        name={name}
        {...rest}
      >
        {name}
      </IntegrationTabPanel>
    )
    const tab = (
      <Tab
        key={name}
        className={styles.tab}
        id={name}
        panel={isDesktopWidth ? tabPanel : undefined}
        panelClassName={isDesktopWidth ? styles.tabPanel : undefined}
        title={<Image alt={name} height={height} src={img} width={width} />}
      />
    )
    acc.push(tab)

    if (!isDesktopWidth && selectedTabId === name) {
      acc.push(tabPanel)
    }
    return acc
  }, [])

  return (
    <Section paddingBottom={0} wrapperClassName={styles.wrapper}>
      <Tabs
        className={styles.tabs}
        id="integrations-tabs"
        listClassName={styles.tabList}
        onChange={setSelectedTabId}
        selectedTabId={selectedTabId}
        vertical
      >
        {renderTabs()}
      </Tabs>
    </Section>
  )
}
